import { ProductEligibilityStatus } from '@asurion-core/asp-core';

export const PRODUCT_SKU_DEFAULT_ELIGIBILITY_MAP = new Map([
  ['ASURIONCOMPLETEPROTECT', ProductEligibilityStatus.Eligible],
  ['VZN_AAL', ProductEligibilityStatus.Eligible],
  ['VZN_ACC', ProductEligibilityStatus.Eligible],
  ['VZN_VMPMD', ProductEligibilityStatus.External],
  ['MCAFEEADVANCED', ProductEligibilityStatus.Eligible],
  ['MCAFEEULTIMATE', ProductEligibilityStatus.Eligible],
  ['MCAFEEPCOPTIMIZER', ProductEligibilityStatus.Eligible],
  ['MCAFEEADVANCED_SECURITYSCAN', ProductEligibilityStatus.Eligible],
  ['MCAFEEESSENTIALTWOYEAR', ProductEligibilityStatus.Eligible],
  ['MCAFEEPREMIUM', ProductEligibilityStatus.Eligible],
  ['OPTIMUM-PPS', ProductEligibilityStatus.Eligible],
  ['TECHASSIST', ProductEligibilityStatus.Eligible],
  ['TECHASSISTPROTECT', ProductEligibilityStatus.Eligible],
  ['TECHASSISTCOMPLETE', ProductEligibilityStatus.Eligible],
  ['ATT_MI_FIBER', ProductEligibilityStatus.Eligible],
  ['ATT_INTERNET_AIR', ProductEligibilityStatus.Eligible],
]);
